
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue-packages",
      function () {
        return require("private-next-pages/venue-packages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue-packages"])
      });
    }
  